module.exports = __webpack_public_path__ + "static/media/video02.440c187b.jpg";